/**
 * Provider Button Handler
 *
 * When a provider is selected (via Find a Provider page), swaps the
 * "FIND A PROVIDER" button to "CALL YOUR PROVIDER" and links to
 * the provider's microsite page.
 */
(function () {
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  function updateProviderButton() {
    // Find the button by data attribute or by matching text content
    var button = document.querySelector("[data-provider-button]");
    if (!button) {
      var links = document.querySelectorAll(".wt-product__button-block a");
      for (var i = 0; i < links.length; i++) {
        if (links[i].textContent.trim() === "FIND A PROVIDER") {
          button = links[i];
          break;
        }
      }
    }
    if (!button) return;

    var locationId = getCookie("location_id");
    if (!locationId) return;

    // Try to get provider data from localStorage
    var providerDataStr = localStorage.getItem("provider_data");
    if (!providerDataStr) return;

    try {
      var provider = JSON.parse(providerDataStr);

      // Verify stored provider matches the cookie
      if (String(provider.id) !== String(locationId)) return;

      // Build the microsite URL from location_handle
      if (provider.location_handle) {
        var programId = getCookie("program_id");
        var micrositeUrl = "/pages/provider/" + provider.location_handle;
        if (programId) {
          micrositeUrl += "?programId=" + programId;
        }

        button.href = micrositeUrl;
        button.textContent = "CALL YOUR PROVIDER";
      }
    } catch (e) {
      // Invalid JSON in localStorage, ignore
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateProviderButton);
  } else {
    updateProviderButton();
  }
})();
